export const CHART_SYNC_DISCLAIMER_CONTENT = {
  title: 'Chart-sync & Auto-saving charts are finally here!',
  description: 'Starting next week, an important rollout regarding charts will be released on all platforms. You will finally be able to access your saved charts across devices with auto-sync & seamless capabilities.',
  featuresTitle: 'What’s changing?',
  featuresDescription: 'Previously, charts were stored locally. We’re now upgrading to cloud storage, ensuring all your layouts, drawings, and templates are saved and accessible anytime, anywhere. Key things to know:',
  features: [
    'Save up to 20 chart layouts, each supporting over 200 scrips.',
    'One-time sync: All your local charts will be uploaded to the cloud.',
    'File size limit: Layouts exceeding 800 KB (including drawings/content) won’t be saved.',
    'Local storage cleanup: Any unsynced layouts will be deleted.',
  ],
  benefitsTitle: 'Benefits of Cloud-Synced Charts on Upstox',
  benefits: [
    'Access Anywhere, Anytime – Switch between Upstox Web and Mobile without losing your chart setups',
    'Auto-Save & Sync – No reworking on your charts! Your layouts, drawings, and templates are automatically saved in the cloud',
    'One-Time Migration – All existing local charts will be synced, ensuring a smooth transition - Enhanced Security – No risk of losing charts due to browser cache clearing or device changes',
  ],
  instructions: 'To ensure a smooth transition, review and update your chart layouts before the migration.',
};
